<app-document-countries
  [name]="'Перечень запчастей для клиентов'"
  [countries]="countries"
></app-document-countries>

